import api from './Api';

export const CompanyApi = {
  // Get companies (filtered by user, except for admin)
  list: () => api.get('/companies'),
  
  // Get ALL companies (admin only - for management purposes)
  getAllForAdmin: () => api.get('/companies/admin/all'),
  
  // Get companies for specific user (admin only - for user management)
  userCompanies: (userId: number) => api.get(`/companies/${userId}`),
  
  // Get products for a company
  products: (companyId: number, includeDeleted = false) =>
    api.get(`/companies/${companyId}/products${includeDeleted ? '?includeDeleted=true' : ''}`),
  // Get products including hidden/deleted
  productsWithHidden: (companyId: number) => api.get(`/companies/${companyId}/products?includeDeleted=true`),
  
  // Add product to a company
  addProduct: (companyId: number, product: any) => api.post(`/companies/${companyId}/products`, product),
  
  // Assign user to company
  assignToUser: (userId: number, companyId: number) => api.post(`/companies/${companyId}/users/${userId}`),

  // Assign a user's access to a specific deposit under a company (admin)
  assignUserToCompanyDeposit: (companyId: number, depositId: number, userId: number) =>
    api.post(`/companies/${companyId}/deposits/${depositId}/users/${userId}`),

  // Remove user's access from a deposit under a company (admin)
  removeUserFromCompanyDeposit: (companyId: number, depositId: number, userId: number) =>
    api.post(`/companies/${companyId}/deposits/${depositId}/users/${userId}/remove`),
  
  // Remove user from company
  removeFromUser: (userId: number, companyId: number) => api.delete(`/companies/${companyId}/users/${userId}`),
  
  // Create new company
  create: (company: any) => api.post('/companies', company),
};